import React from 'react'

import { Grid, Container, Icon, Card } from 'semantic-ui-react'

import { NormalHeader } from '../../pages/main_page/components/style'
import { MoreNews, NewsContainer, NewsProjectName, NewsCard, NewsDate } from './style'

import { themes } from '@/theme/context'

export const NewsComponent = ({ news, currentAct }) => {
    if (!news) return null;

    return (
        <NewsContainer>
            <NormalHeader as='h1'>{currentAct !== 'olymp_en' ? 'Новости' : 'News'}</NormalHeader>
            <Card.Group itemsPerRow={1}>
                {news.slice(0,4).map((item, id) => {
                    const date = new Date(item.date),
                        formattedDate = date.toLocaleString('ru-RU', { day: 'numeric', month: 'numeric', year: 'numeric' })

                    return <NewsCard key={id}>
                        <Card.Content>
                            <Container>
                                <Grid stackable>
                                    <Grid.Row>
                                        <Grid.Column width={12}>
                                            <NewsProjectName $color={themes[item.mode]?.primaryColor || themes.default.primaryColor}>
                                                <Icon name="circle" size='small'/>{item.name}
                                            </NewsProjectName>
                                            <Card.Description>{item.title}<a className='hiddenMobile' href={item.href}>{currentAct !== 'olymp_en' ? 'Читать...' : 'Read...'}</a></Card.Description>
                                        </Grid.Column>
                                        <Grid.Column width={4} textAlign="right" verticalAlign="bottom">
                                            <NewsDate>{formattedDate}</NewsDate>
                                            <a className='hiddenDesktop' href={item.href}>{currentAct !== 'olymp_en' ? 'Читать...' : 'Read...'}</a>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Container>
                        </Card.Content>
                    </NewsCard>
                })}
            </Card.Group>
            <MoreNews>
                <a href="/all_news">{currentAct !== 'olymp_en' ? 'Больше новостей' : 'More'}</a>
            </MoreNews>
        </NewsContainer>
    )
}
